import type { IconDefinition } from "@fortawesome/pro-solid-svg-icons";
import {
    faCircleExclamation,
    faTriangleExclamation,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Typography from "@vapor/react-extended/ExtendedTypography";
import { Stack, useTheme } from "@vapor/react-material";
import { TaxSubmissionStatus } from "../../../core/dtos/TaxSubmissionStatus";

interface TaxSubmissionStatusAlertProps {
    status: TaxSubmissionStatus;
    numberOfWarnings?: number;
}
export const TaxSubmissionStatusAlert: React.FC<
    TaxSubmissionStatusAlertProps
> = ({ status, numberOfWarnings }): JSX.Element => {
    const theme = useTheme();

    let color: string;
    let icon: IconDefinition | undefined;
    let text: string | undefined;

    switch (status) {
        case TaxSubmissionStatus.GENERIC_ERROR:
        case TaxSubmissionStatus.NOT_SENT_WITH_ERRORS:
            color = theme.palette.primary.accentRustyRed;
            icon = faCircleExclamation;
            break;
        case TaxSubmissionStatus.SENT:
            color = theme.palette.primary.baseWarningColor;
            icon =
                numberOfWarnings && numberOfWarnings > 0
                    ? faTriangleExclamation
                    : undefined;
            text = "(" + numberOfWarnings + ")";
            break;
        default:
            color = theme.palette.primary.interactiveDefault;
            icon = undefined;
            text = undefined;
            break;
    }

    return icon ? (
        <Stack
            alignItems="center"
            direction="row"
            overflow="hidden"
            spacing={1}
            whiteSpace="nowrap"
        >
            <FontAwesomeIcon color={color} icon={icon} size="lg" />
            <Typography
                color={theme.palette.primary.textTitleColor}
                overflow="hidden"
                textOverflow="ellipsis"
                variant="subtitle"
            >
                {text}
            </Typography>
        </Stack>
    ) : (
        <></>
    );
};
